import { takeEvery, put, call } from "redux-saga/effects"

import {
  GET_FINANCE_REPORT,
  GET_FINANCE_REPORT_DETAIL_LIST,
  GET_SERVICE_REPORT,
  UPDATE_FINANCE_REPORT_DETAIL,
  UPSERT_FINANCE_REPORT,
} from "./actionTypes"
import { serializeQuery } from "helpers/service_helper"

const {
  upsertFinanceReportApi,
  getFinanceReportApi,
  getFinanceReportDetailListApi,
  updateFinanceReportDetailApi,
  getServiceReportApi,
} = require("helpers/backend_helper")
const {
  upsertFinanceReportSuccess,
  upsertFinanceReportFail,
  getFinanceReportSuccess,
  getFinanceReportFail,
  updateFinanceReportDetailSuccess,
  updateFinanceReportDetailFail,
  getFinanceReport,
  getFinanceReportDetailList,
  getFinanceReportDetailListSuccess,
  getFinanceReportDetailListFail,
  getServiceReportSuccess,
  getServiceReportFail,
} = require("./actions")

function* onUpsertFinanceReport({ payload: data }) {
  try {
    const financeReportId = yield call(upsertFinanceReportApi, data)
    const result = { financeReportId }
    const params = serializeQuery(result)
    yield put(upsertFinanceReportSuccess("با موفقیت ایجاد شد"))
    yield put(getFinanceReport())
    yield put(getFinanceReportDetailList(params))
  } catch (error) {
    yield put(upsertFinanceReportFail(error))
  }
}

function* onGetFinanceReport() {
  try {
    const result = yield call(getFinanceReportApi)

    yield put(getFinanceReportSuccess(result))
  } catch (error) {
    yield put(getFinanceReportFail(error))
  }
}

function* onGetFinanceReportDetailList({ payload: values }) {
  try {
    const result = yield call(getFinanceReportDetailListApi, values)
    yield put(getFinanceReportDetailListSuccess(result))
  } catch (error) {
    yield put(getFinanceReportDetailListFail(error))
  }
}

function* onUpdateFinanceReportDetail({ payload: data }) {
  try {
    const result = yield call(updateFinanceReportDetailApi, data)
    yield put(updateFinanceReportDetailSuccess(result))
  } catch (error) {
    yield put(updateFinanceReportDetailFail(error))
  }
}

function* onGetServiceReport({ payload: data }) {
  try {
    const result = yield call(getServiceReportApi, data)

    yield put(getServiceReportSuccess(result))
  } catch (error) {
    yield put(getServiceReportFail(error))
  }
}

function* saga() {
  yield takeEvery(UPSERT_FINANCE_REPORT, onUpsertFinanceReport)
  yield takeEvery(GET_FINANCE_REPORT, onGetFinanceReport)
  yield takeEvery(GET_SERVICE_REPORT, onGetServiceReport)
  yield takeEvery(GET_FINANCE_REPORT_DETAIL_LIST, onGetFinanceReportDetailList)
  yield takeEvery(UPDATE_FINANCE_REPORT_DETAIL, onUpdateFinanceReportDetail)
}

export default saga
